var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Summary'),_c('financialRisk'),_c('KeyFinanceRatio'),_c('UpDownCustomer'),_c('PurchaseAndSale'),_c('FinanceAndDuban'),_c('HistoryTaxCondition')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }